import { render } from "./ShopSectionNav.vue?vue&type=template&id=6f4d0c80&scoped=true"
import script from "./ShopSectionNav.vue?vue&type=script&lang=js"
export * from "./ShopSectionNav.vue?vue&type=script&lang=js"

import "./ShopSectionNav.vue?vue&type=style&index=0&id=6f4d0c80&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f4d0c80"]])

export default __exports__